import { useState } from "react";
import { BlockNoteEditor } from "@blocknote/core";
import { useBlockNoteEditor } from "@blocknote/react";
import styled from "@emotion/styled";
import { Text } from "styles/utility-components";

import { DropdownMenu, DropdownMenuTrigger } from "components/ui/dropdown_menu";
import { createUseDebounce } from "lib/debounce";
import { getWordAndCharacterCount } from "../utils";

export default function WordCountButton() {
  const editor = useBlockNoteEditor();
  const [counts, setCounts] = useState({ words: 0, characters: 0 });

  const useDebounce = createUseDebounce(500);
  const debouncedOnEditorChanged = useDebounce(({ document }: BlockNoteEditor) => {
    setCounts(getWordAndCharacterCount(document));
  });

  editor.onChange(debouncedOnEditorChanged);

  return (
    <DropdownMenu
      width="fit-content"
      trigger={
        <DropdownMenuTrigger buttonType="primary" buttonStyle="inverse">
          Word count
        </DropdownMenuTrigger>
      }
    >
      <MenuItem>{counts.words} words</MenuItem>
      <MenuItem>{counts.characters} characters</MenuItem>
    </DropdownMenu>
  );
}

const MenuItem = styled(Text)({
  padding: "4px 12px",
});
